import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { SettingProvider } from '../../lib/context/settings';
import { AdsProvider } from '../../lib/context/ads';
import { Button, Col, Row } from 'antd';
import { SecondaryTitle, Title } from '../../components/styles';
import { device } from '../../lib/theme';
import styled from 'styled-components';

const HeroContainer = styled(Row)`
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  background-image: url(https://aaacdndev.blob.core.windows.net/wordpress/2019/11/desktop_HeroImage@2x.jpg);
  height: 500px;
  margin: auto;
  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;
const SpecialOfferContainer = styled(Row)`
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  background-image: url(https://aaacdndev.blob.core.windows.net/wordpress/2019/11/CC_STAR_Livorno_Panorama_Sunset@2x.jpg);
  height: 250px;
  margin: auto;
  margin-top: 62px;
  margin-bottom: 62px;
  justify-content: center;
  align-items: center;
  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;

const GetMoreContainer = styled(Row)`
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
`;

const FeaturedCards = styled.div`
  max-width: 440px;
  max-height: 440px;
  width: 95%;
  height: 340px;
  background-size: cover;
  background-position: center center;
  border-radius: 10px;
  overflow: hidden;
  display: inline-flex;
  flex-flow: column nowrap;
  transition: 0.3s all ease-in-out;
  justify-content: flex-end;
  margin: 8px;
`;

const FeaturedCardTitles = styled.div`
  width: 100%;
  background: rgba(0, 85, 155, 0.9);
  padding: 24px;
  justify-content: flex-start;
  position: relative !important;
`;

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const VikingCruiseLP: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="Viking Cruises"
              description="Viking sails the storied rivers of Europe. AAA Members get exclusive discounts with Viking Cruises when they book with AAA Travel."
              canonicalUrl="/travel/viking-cruises"
              image="https://aaacdndev.blob.core.windows.net/wordpress/2019/11/desktop_HeroImage@2x.jpg"
            />

            <HeroContainer align="middle" justify="center">
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <p style={{ color: 'white', fontSize: 24, marginBottom: 0 }}>
                  Exploring the World in Comfort
                </p>
                <Title white>Viking Cruises</Title>

                <Button
                  style={{ marginTop: 32 }}
                  type="primary"
                  href="https://travel-booking.acg.aaa.com/cruise/cruises#cruiseLine=VO&cruiseLine=VR"
                >
                  See Cruises
                </Button>
              </Col>
            </HeroContainer>

            <Row style={{ paddingTop: 48, marginBottom: 128 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <GetMoreContainer>
                  <Col xs={{ span: 0 }} md={{ span: 12 }}>
                    <img
                      style={{ width: '100%' }}
                      src="https://aaacdndev.blob.core.windows.net/wordpress/2019/11/GetMore@2x.jpg"
                    />
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 10, offset: 1 }}>
                    <h2 style={{ marginTop: 24 }}>GET MORE WITH AAA</h2>
                    <p>Viking River Cruises:</p>
                    <p>AAA MEMBER BENEFIT:</p>
                    <p>
                      $100 per person shipboard credit for all cruises 8-11
                      days.
                    </p>
                    <p>
                      $200 per person shipboard credit for all cruises 12 days
                      or longer.{' '}
                    </p>
                    <p>
                      <i>
                        Onboard spending credit is valid for onboard purchases –
                        bar, boutique, excursions and onboard gratuities.
                        Shipboard credits can only be applied when booked by a
                        AAA Travel Advisor.
                      </i>
                    </p>
                    <p>
                      You must book through AAA to receive these benefits. If
                      you&apos;re not a member, you can become one for as low as
                      $59!{' '}
                      <a href="https://join.carolinas.aaa.com/?promo=INTRNET">
                        <strong>JOIN NOW</strong>
                      </a>
                    </p>
                    <p>
                      <strong>
                        <span className="bold">
                          Need Help with your vacation? Call us at{' '}
                        </span>
                        <a href="tel:1-800-444-8691">800-444-8691</a>{' '}
                      </strong>
                    </p>
                  </Col>
                </GetMoreContainer>
                <Row>
                  <Col md={{ span: 24 }}>
                    <SpecialOfferContainer>
                      <Col
                        xs={{ span: 22, offset: 1 }}
                        md={{ span: 20, offset: 2 }}
                      >
                        <Title white style={{ marginBottom: 16 }}>
                          Special Offers
                        </Title>
                        <Button
                          type="primary"
                          href="https://carolinas.membervacationportal.com/4610876/viking-cruises-special-offers"
                        >
                          {' '}
                          View Deals
                        </Button>
                      </Col>
                    </SpecialOfferContainer>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 6, offset: 6 }}>
                    <FeaturedCards
                      style={{
                        backgroundImage:
                          'url(https://aaacdndev.blob.core.windows.net/wordpress/2019/11/desktop_HeroImage@2x.jpg',
                        backgroundPosition: 'cover',
                      }}
                    >
                      <a
                        style={{ width: '100%' }}
                        href="https://travel-booking.acg.aaa.com/cruise/cruises#cruiseLine=VR"
                      >
                        <FeaturedCardTitles>
                          <h3 style={{ color: 'white' }}>
                            Viking River Cruises
                          </h3>

                          <h4 style={{ color: 'white' }}>See Cruises</h4>
                        </FeaturedCardTitles>
                      </a>
                    </FeaturedCards>
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 6 }}>
                    <FeaturedCards
                      style={{
                        backgroundImage:
                          'url(https://aaacdndev.blob.core.windows.net/wordpress/2019/11/Box2@2x.jpg',
                        backgroundPosition: 'cover',
                      }}
                    >
                      <a
                        style={{ width: '100%' }}
                        href="https://travel-booking.acg.aaa.com/cruise/cruises#cruiseLine=VO"
                      >
                        <FeaturedCardTitles>
                          <h3 style={{ color: 'white' }}>
                            Viking Ocean Cruises
                          </h3>

                          <h4 style={{ color: 'white' }}>See Cruises</h4>
                        </FeaturedCardTitles>
                      </a>
                    </FeaturedCards>
                  </Col>
                </Row>
                <Row style={{ alignItems: 'center', marginTop: 32 }}>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      type="link"
                      size="large"
                      href="https://travel-booking.acg.aaa.com/cruise/cruises#cruiseLine=VO&cruiseLine=VR"
                    >
                      Book Now
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      type="link"
                      size="large"
                      href="https://locator.carolinas.aaa.com/?type=travel"
                    >
                      Find an Agent
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button type="link" size="large" href="tel:800-444-8691">
                      Call 800-444-8691
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      type="link"
                      size="large"
                      href="https://carolinas.aaa.com/travel/quote/"
                    >
                      Request a Quote
                    </Button>
                  </Col>
                </Row>
                <Row style={{ marginTop: 64 }}>
                  <SecondaryTitle style={{ margin: 'auto' }}>
                    Learn More About VIking Cruises
                  </SecondaryTitle>
                  <p style={{ marginTop: 16, marginBottom: 32 }}>
                    Viking sails the storied rivers of Europe with award-winning
                    Viking Longships offering a variety of stateroom categories
                    and suites. Onboard you will enjoy a restaurant, bar, lounge
                    and expansive sun deck on cruises ranging from 8 to 23 days.
                    Entering in to ocean cruising in 2015, Viking ships average
                    around 900 guests and its itineraries are specifically
                    designed to maximize the time you spend in your destination.
                  </p>

                  <Col xs={{ span: 24 }} md={{ span: 8 }}>
                    <div style={{ maxWidth: '95%', margin: 'auto' }}>
                      <a href="https://go.carolinas.aaa.com/traveler-magazine/elegant-elbe-river-cruise/">
                        <img
                          style={{ width: '100%' }}
                          src="https://aaacdndev.blob.core.windows.net/wordpress/2019/11/learnmore2@2x-5dc494cfc6841.jpg"
                        />
                        <h3>Blog</h3>
                        <h2>Elegant Elbe</h2>
                      </a>
                    </div>
                  </Col>

                  <Col xs={{ span: 24 }} md={{ span: 8 }}>
                    <div style={{ maxWidth: '95%', margin: 'auto' }}>
                      <a href="https://go.carolinas.aaa.com/traveler-magazine/slow-boat-through-china-35080/">
                        <img
                          style={{ width: '100%' }}
                          src="https://aaacdndev.blob.core.windows.net/wordpress/2019/11/learnmore5@2x-5dc494ef44eb1.jpg"
                        />
                        <h3>Blog</h3>
                        <h2>Slow Boat Through China</h2>
                      </a>
                    </div>
                  </Col>
                </Row>
                <Row style={{ alignItems: 'center', marginTop: 64 }}>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      type="link"
                      size="large"
                      href="https://travel-booking.acg.aaa.com/cruise/cruises#cruiseLine=VO&cruiseLine=VR"
                    >
                      Book Now
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      type="link"
                      size="large"
                      href="https://locator.carolinas.aaa.com/?type=travel"
                    >
                      Find an Agent
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button type="link" size="large" href="tel:800-444-8691">
                      Call 800-444-8691
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 6 }}
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      type="link"
                      size="large"
                      href="https://carolinas.aaa.com/travel/quote/"
                    >
                      Request a Quote
                    </Button>
                  </Col>
                </Row>
                <Row
                  style={{
                    textAlign: 'center',
                    backgroundColor: '#324e5f',
                    color: 'white',
                    paddingTop: 24,
                    paddingBottom: 24,
                    marginTop: 64,
                  }}
                >
                  <Col
                    xs={{ span: 22, offset: 1 }}
                    md={{ span: 20, offset: 2 }}
                  >
                    <SecondaryTitle white>
                      Attend Our Travel Events
                    </SecondaryTitle>
                    <p>
                      You are invited to join your local AAA Travel Agents for
                      fun and informative events. Discover destinations, get the
                      scoop from our preferred travel partners and discover the
                      exclusive benefits AAA members can receive when they book
                      their travel with AAA.
                    </p>
                    <a href="https://carolinas.aaa.com/events/?zip=28027&devicecd=PC">
                      <strong>
                        <p>See Events</p>
                      </strong>
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default VikingCruiseLP;
